<template>
    <div class="scope-inline-tabs">
        <div
            :class="['scope-inline-tab', { '-active': currentTab == tab.id }]"
            v-for="(tab, index) in tabs"
            @click="goToSection(tab.id)"
            :key="index"
        >
            {{ tab.name }}
        </div>
    </div>
</template>

<script setup>
defineProps({
    tabs: Array
});
const currentTab = defineModel();
const goToSection = (tabId) => {
    currentTab.value = tabId;
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-inline-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  background: inherit;

  .scope-inline-tab {
    color: $text-mid-emphasis;
    @include fz-14;
    font-weight: 500;
    text-wrap: nowrap;
    cursor: pointer;
    @include transition-default(color);

    &.-active {
      color: $text-high-emphasis;
    }

    @media (min-width: 768px) {
      &:not(.-active):hover {
        color: $text-low-emphasis;
      }
    }
  }
}
</style>
